// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rabbit-sign-docs .rabbit-sign-document-card {
  padding: 0px;
}
.rabbit-sign-docs .rabbit-sign-document-card .ant-card-head,
.rabbit-sign-docs .rabbit-sign-document-card .ant-card-body {
  padding: 0px 10px;
}
.rabbit-sign-docs .rabbit-sign-document-card div > div > div > .rabbit-sign-docs-card-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.rabbit-sign-docs .rabbit-sign-document-card div > div > div > .rabbit-sign-docs-card-header .card-title {
  margin-top: 8px;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-doc-cell .rabbit-sign-doc-status {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-doc-cell .rabbit-sign-doc-status .rabbit-sign-document-info-popover-icon .rabbit-sign-document-info-popover {
  width: 500px;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-signer-list .rabbit-sign-signer {
  margin: 3px 0px;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-signer-list .rabbit-sign-signer span > .signer-tag {
  margin: 0px 5px;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-signer-list .rabbit-sign-signer .rabbit-sign-document-signers-popover {
  padding: 0px 12px;
  display: inline-flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/rabbit-sign/components/esign-documents/styles.less"],"names":[],"mappings":"AAAA;EAEI,YAAA;AAAJ;AAFA;;EAKM,iBAAA;AACN;AANA;EASM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAN;AAZA;EAeQ,eAAA;AAAR;AAfA;EAsBU,aAAA;EACA,mBAAA;EACA,8BAAA;AAJV;AApBA;EA4Bc,YAAA;AALd;AAvBA;EAoCU,eAAA;AAVV;AA1BA;EAuCY,eAAA;AAVZ;AA7BA;EA2CY,iBAAA;EACA,oBAAA;AAXZ","sourcesContent":[".rabbit-sign-docs {\n  .rabbit-sign-document-card {\n    padding: 0px;\n\n    .ant-card-head, .ant-card-body {\n      padding: 0px 10px;\n    }\n\n    div > div > div > .rabbit-sign-docs-card-header {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      .card-title {\n        margin-top: 8px;\n      }\n    }\n\n    .rabbit-sign-docs-table {\n      .rabbit-sign-doc-cell {\n        .rabbit-sign-doc-status {\n          display: flex;\n          flex-direction: row;\n          justify-content: space-between;\n\n          .rabbit-sign-document-info-popover-icon {\n            .rabbit-sign-document-info-popover {\n              width: 500px;\n            }\n          }\n        }\n      }\n\n      .rabbit-sign-signer-list {\n        .rabbit-sign-signer {\n          margin: 3px 0px;\n\n          span > .signer-tag {\n            margin: 0px 5px;\n          }\n\n          .rabbit-sign-document-signers-popover {\n            padding: 0px 12px;\n            display: inline-flex;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
